import { Fragment, useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import FleetWebApi from "../Api/FleetWebApi";
import ResultsDetails from "./ResultDetails";
import Container from "@mui/material/Container";
import { useAuthDataContext } from "../AuthDataProvider";
import { CSVLink } from "react-csv";

export default function ChargifyShopifyResult(props) {
  // set initial values
  const [netSuiteError, setNetSuiteError] = useState(null);
  const [isNetSuiteLoaded, setIsNetSuiteLoaded] = useState(false);
  const [shopifyError, setShopifyError] = useState(null);
  const [isShopifyLoaded, setIsShopifyLoaded] = useState(false);
  const [chargifyError, setChargifyError] = useState(null);
  const [isChargifyLoaded, setIsChargifyLoaded] = useState(false);
  const [deviceList, setDeviceList] = useState(null);
  const { user } = useAuthDataContext();

  // component render
  useEffect(() => {
    setIsNetSuiteLoaded(false);
    setIsChargifyLoaded(false);
    setIsShopifyLoaded(false);
    if (props.code.substring(0, 3) === "SO-") {
      getNetSuite(props.code);
    } else {
      // check if code returns any devices as a shopify code
      getShopify(props.code);
    }
  }, [props.code]);
  useEffect(() => {
    if (shopifyError) {
      getChargify(props.code);
    }
  }, [isShopifyLoaded]);

  const getNetSuite = (code) => {
    if (user && user.token) {
      FleetWebApi.getNetSuiteFromMfgWeb(code, user.token).then(
        (result) => {
          if (result) {
            setIsNetSuiteLoaded(true);
            setDeviceList(result);
          }
        },
        (error) => {
          setNetSuiteError(error);
          setIsNetSuiteLoaded(true);
        }
      );
    }
  };

  const getShopify = (code) => {
    FleetWebApi.getDevicesOnShopifyOrder(code).then(
      (result) => {
        if (result && result.length !== 0) {
          setIsShopifyLoaded(true);
          setDeviceList(result);
        }
      },
      (error) => {
        setShopifyError(error);
        setIsShopifyLoaded(true);
      }
    );
  };

  const getChargify = (code) => {
    FleetWebApi.getDevicesOnChargifyOrder(code).then(
      (result) => {
        if (result && result.length !== 0) {
          setIsChargifyLoaded(true);
          setDeviceList(result);
        }
      },
      (error) => {
        setChargifyError(error);
        setIsChargifyLoaded(true);
      }
    );
  };

  let searchResultsContainer;
  if (netSuiteError || (shopifyError && chargifyError)) {
    searchResultsContainer = (
      <div>
        {netSuiteError ? "Couldn't fetch from netsuite" : shopifyError.message}
      </div>
    );
  } else if (!isNetSuiteLoaded && !isShopifyLoaded && !isChargifyLoaded) {
    searchResultsContainer = (
      <div>
        <CircularProgress color="secondary" />
      </div>
    );
  } else {
    searchResultsContainer = (
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12} md={8} lg={5}>
            <ResultsDetails deviceListDetails={deviceList} />
          </Grid>
          <Grid item xs={12} md={8} lg={5}>
            {deviceList && deviceList.length !== 0 ? (
              <CSVLink
                data={deviceList.map((x) => `${x}`).join("\n")}
                filename={"devices_.csv"}
              >
                Download CSV
              </CSVLink>
            ) : null}
          </Grid>
        </Grid>
      </Container>
    );
  }

  return (
    <Fragment>
      <h1>Search Results for: {props.code}</h1>
      <Grid>{searchResultsContainer}</Grid>
    </Fragment>
  );
}
